// Where to send the user after they click OK.
// CHANGE THIS if your landing page is not "/login".
const REDIRECT_PATH = '/login';

let popupShown = false;

export function isSessionPopupShown() {
  return popupShown;
}

export function showSessionTerminatedPopup(
  message = 'You have been logged out because your account was logged in on another device.'
) {
  if (popupShown) return; // several failing requests can trigger this at once
  popupShown = true;

  const overlay = document.createElement('div');
  overlay.style.cssText =
    'position:fixed;inset:0;background:rgba(0,0,0,0.55);z-index:2147483647;' +
    'display:flex;align-items:center;justify-content:center;font-family:sans-serif;';

  const box = document.createElement('div');
  box.style.cssText =
    'background:#fff;border-radius:12px;padding:24px;max-width:360px;width:88%;' +
    'text-align:center;box-shadow:0 10px 30px rgba(0,0,0,0.3);';

  const title = document.createElement('h3');
  title.textContent = 'Session Expired';
  title.style.cssText = 'margin:0 0 12px;font-size:20px;';

  const text = document.createElement('p');
  text.textContent = message;
  text.style.cssText = 'margin:0 0 20px;font-size:15px;color:#333;';

  const button = document.createElement('button');
  button.textContent = 'OK';
  button.style.cssText =
    'background:#0A57FF;color:#fff;border:none;border-radius:8px;' +
    'padding:10px 32px;font-size:15px;font-weight:bold;cursor:pointer;';
  button.onclick = () => {
    window.location.href = REDIRECT_PATH;
  };

  box.append(title, text, button);
  overlay.appendChild(box);
  document.body.appendChild(overlay);
}